const state = {
  id: null,
  deadline: '',
  deep_link_id: undefined,
  provider_id: undefined,
  service_id: undefined,
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'service_id' },
]

export default state
